module.exports = {
  title: '物联网管理平台' // 浏览器 tab 标签标题
}
